import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';
import Moment from 'react-moment';

import './styles.css';
import {
  connect as reduxConnect,
  actions as allActions
} from '../../reducers/index';
import Navigation from '../../components/Navigation';
import Footer from '../../components/Footer';
import logo from './img/IAR_logo_wht.png';
import mentalHealth from "./img/uoft-mh.png";
import healthWellness from "./img/hw_logo.jpg";

class Certificate extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.props.onTrainingCompletedInitialize();
  }

  render() {
    const { role, contact } = this.props;

    return (
      <div className="contact-form-page">
        <Navigation role={role} />
        <section>
          <div id="maincontent" className="container">
            <table id="table" border="0" cellSpacing="0" cellPadding="0" style={{ backgroundColor: "#FFFFFF", border: "30px solid #2152B8", margin: "3%", width: "94%" }}>
              <tbody>
                <tr valign="top">

                  <td cellPadding="0" style={{ paddingLeft: 100 }}>
                    <table style={{ marginTop: -38, position: "relative", zIndex: 9 }}>
                      <tbody>
                        <tr>
                          <td id="logoBackground" style={{ border: "3px solid #ffffff", borderTop: "1px solid #ffffff", textAlign: "center", padding: 30, backgroundColor: "#64B30E" }}>
                            <img style={{ margin: 0 }} alt="IAR - Identify Assist Refer" src={logo} width="220" height="auto" />
                          </td>
                        </tr>
                        <tr>
                          <td id="certificate" style={{ border: "3px solid #ffffff", borderTop: 0, padding: 30, textAlign: "center", fontFamily: "helvetica, arial, sans-serif", backgroundColor: "#2152B8", color: "#ffffff", fontSize: 34 }}>
                            CERTIFICATE<br />
                            <span id="onlineTraining" style={{ fontSize: "20px" }}>Identify, Assist, Refer Online</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                  <td id="mentalHealth" style={{ padding: "0 1em 0 0", textAlign: "right", float: "right" }}>
                    <div>
                      <img style={{ margin: 0 }} alt="Mental Health" src={mentalHealth} width="300" height="auto" />
                    </div>
                  </td>
                </tr>
                <tr>
                  <td colSpan="2" style={{ padding: "1em" }}>
                    <p style={{ fontFamily: "Helvetica, Arial,sans-serif", margin: "50px auto 10px", color: "#333333", fontSize: "34px", textAlign: "center" }}>
                      {contact.nameText}
                    </p>
                    <p style={{ width: "80%", margin: "2em auto 10px", fontFamily: "Helvetica, Arial,sans-serif", color: "#707070", fontSize: "16px", lineHeight: "1.4em", textAlign: "center", fontStyle: "italic" }}>
                    has completed Identify, Assist, Refer offered by Health & Wellness. This training helps prepare the participant to be able to identify someone experiencing a mental health challenge, offer assistance, and facilitate help-seeking behaviour.
                  </p>
                  </td>
                </tr>
                <tr valign="bottom">
                  <td width="50%" style={{ padding: "1em" }}>
                    <p style={{ margin: 0, fontFamily: "Helvetica, Arial,sans-serif", color: "#707070", fontSize: "11px", lineHeight: "1.2em" }}>
                    This certificate denotes successful completion of Identify, Assist, Refer and should not be interpreted as a recognized certificate from the University of Toronto.
                  </p>
                  </td>
                  <td width="50%" style={{ padding: "1em", textAlign: "right", float: "right" }}>
                    <div>
                      <a href="http://www.studentlife.utoronto.ca/" target="_blank" rel="noopener noreferrer">
                        <img style={{ margin: 0 }} alt="Health and Wellness" src={healthWellness} width="120" height="auto" />
                      </a>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>
        <Footer />
      </div >
    );
  }
}

Certificate.propTypes = {
  role: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  contact: PropTypes.object.isRequired // eslint-disable-line react/forbid-prop-types
};

export default reduxConnect.training(reduxConnect.contact(reduxConnect.role(Certificate)));



// WEBPACK FOOTER //
// ./src/containers/CertificatePage/index.jsx